import Action from 'redux/helpers/createAction'
const name = 'selection'

export const setSelection = Action(name + '/SET', selection => ({
  selection
}))

export const clearSelection = Action(name + '/DESELECTALL')

export const tagSet = Action(name + '/TAG_SET', selection => ({
  selection
}))

export const tagToggleAll = Action(name + '/TAG_TOGGLEALL', selectAll => ({
  selectAll
}))

export const tagDeselectAll = Action(name + '/TAG_DESELECTALL')

export const resetSelections = Action(name + '/RESET_SELECTION')
